interface JWT {
  aud: string;
  exp: number;
  iat: number;
  iss: string;
  jti: string;
  nbf: number;
  sub: string;
  typ: string;
}

const jwtProperties: { key: keyof JWT; type: "string" | "number" }[] = [
  { key: "aud", type: "string" },
  { key: "exp", type: "number" },
  { key: "iat", type: "number" },
  { key: "iss", type: "string" },
  { key: "jti", type: "string" },
  { key: "sub", type: "string" },
  { key: "typ", type: "string" },
];

// Function is a typescript port of this SO answer https://stackoverflow.com/a/38552302
export const parseJwt = (token: string): JWT | never => {
  const base64Url = token.split(".")[1];
  const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split("")
      .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
      .join("")
  );

  const jwt = JSON.parse(jsonPayload);

  for (const property of jwtProperties) {
    if (
      jwt[property.key] === undefined ||
      typeof jwt[property.key] !== property.type
    ) {
      throw new Error(`JWT is missing property ${property.key}`);
    }
  }

  return jwt as JWT;
};
